module.exports = __webpack_public_path__ + "img/img-a9878a12.200f97a9.png";